export const mutations = {
    updateIncident (state, incident) {
        state.incident = incident;
    },

    updateDocuments (state, documents) {
        if (state.incident) {
            const stepData = state.incident.data.find(d => d.id === documents.id);
            stepData.documents = documents.documents;
        }
    },

    updateIncidentEnums (state, payload) {
        state.incidenttypes     = payload.incidenttypes;
        state.forwardings       = payload.forwardings;
        state.deliverytimes     = payload.deliverytimes;
        state.costtypes         = payload.costtypes;
        state.manufacturer      = payload.manufacturer;
        state.zuescompanies     = payload.zuescompanies;
        state.assessmentresults = payload.assessmentresults;
        state.assessmenttypes   = payload.assessmenttypes;
        state.components        = payload.components;
        state.stepdoctypes         = payload.stepdoctypes;
        state.stepdoctypesIds      = state.stepdoctypes.map (s => s.id);
        state.assessmentfaulttypes = payload.assessmentfaulttypes;
        state.postponmentType      = payload.postponmentType;
        state.bidReason            = payload.bidReason;
    },

    updateStepdatahistory (state, payload) {
        state.stepdatahistory = payload;
    },

    updateClipboard (state, payload) {
        state.clipboard = payload;
    },

    updateManufacturerList (state, manufacturer) {
        state.manufacturer.push(manufacturer);
    },

    updateTodo (state, todo) {
        state.todo = todo;
    },
}
